// extracted by mini-css-extract-plugin
export default {"clearCompleted":"BottomBar_clearCompleted__wRUxR","darkMode":"BottomBar_darkMode__q3Pz1"};